import { Option } from "fp-ts/Option";
import { LocaleKey, useFormatMessage } from "../../../../intl";
import { useTenantCurrency } from "../../../../Common/useTenantCurrency";
import {
  ComputedFieldProps,
  FormRow,
  FormSection,
  InputField,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { MoneyField } from "../../../../Common/Price/MoneyField/MoneyField";
import { constVoid, pipe } from "fp-ts/function";
import { array, option } from "fp-ts";
import { ComputedFieldPropsExtended } from "./ExpensesCalculator";
import { useAppContext } from "../../../../useAppContext";
import { foldTenant } from "../../../../globalDomain";
type ExpensesSubFormProps = {
  fields: ComputedFieldPropsExtended<Option<number>>[];
};

export function ExpensesSubForm(props: ExpensesSubFormProps) {
  const formatMessage = useFormatMessage();
  const tenantCurrency = useTenantCurrency();
  const fieldProps = props.fields;
  const {
    apiParameters: { tenant },
  } = useAppContext();

  const getMoneyField = (
    field: ComputedFieldProps<Option<number>>,
    label: LocaleKey
  ) => {
    return (
      <MoneyField
        {...(field as ComputedFieldProps<Option<number>>)}
        decimalDigits={0}
        min={0}
        max={999999999}
        currency={tenantCurrency}
        label={formatMessage(label)}
        placeholder={unsafeLocalizedString("0")}
      />
    );
  };

  const getFieldsWithAlimony = (
    field1: ComputedFieldPropsExtended<Option<number>>,
    field2: ComputedFieldPropsExtended<Option<number>>
  ) => {
    if (field2.name === "necessaryExpensesalimonyAmount") {
      return foldTenant(
        tenant,
        () => (
          <FormRow type={"1-1"}>
            {getMoneyField(field1, field1.translationKey)}
            <InputField
              value={formatMessage(
                "StandardLoan.ExpensesConfirmationRework.Form.Calculator.AlimonyQuestion.value"
              )}
              name="alimonyQuestionField"
              onBlur={constVoid}
              onChange={constVoid}
              rightContent={option.none}
              placeholder={unsafeLocalizedString("")}
              label={formatMessage(field2.translationKey)}
              disabled={true}
              type="text"
              issues={option.none}
            />
          </FormRow>
        ),
        () => (
          <FormRow type={"1-1"}>
            {getMoneyField(field1, field1.translationKey)}
            {getMoneyField(field2, field2.translationKey)}
          </FormRow>
        )
      );
    }

    return (
      <FormRow type={"1-1"}>
        {getMoneyField(field1, field1.translationKey)}
        {getMoneyField(field2, field2.translationKey)}
      </FormRow>
    );
  };

  return (
    <FormSection>
      {pipe(
        fieldProps,
        array.chunksOf(2),
        array.map(arr => {
          if (arr.length === 1) {
            return (
              <FormRow type={"1-1"}>
                {getMoneyField(arr[0], arr[0].translationKey)}
                <></>
              </FormRow>
            );
          }
          return getFieldsWithAlimony(arr[0], arr[1]);
        })
      )}
    </FormSection>
  );
}
